import {
    BodyPrimary,
    BodySecondary,
    Caption,
    H1,
    H2,
    H3,
    H4,
    H5,
    LabelMini,
} from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

type Props = {
    defaultMessage?: string;
    encapsulateP?: boolean;
    id: string;
    inline?: boolean;
    props?: any;
    values?: any;
};

const FormattedMessageText = ({ defaultMessage, encapsulateP, id, inline, values, ...props }: Props) => {
    const textClasses = cn(inline && 'inline');

    const message = (
        <FormattedMessage
            defaultMessage={defaultMessage}
            id={id}
            values={{
                ...values,
                br: <br key="br" />,
                caption: (...msg) => (
                    <Caption
                        key="caption"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </Caption>
                ),
                h1: (...msg) => (
                    <H1
                        key="h1"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </H1>
                ),
                h2: (...msg) => (
                    <H2
                        key="h2"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </H2>
                ),
                h3: (...msg) => (
                    <H3
                        key="h3"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </H3>
                ),
                h4: (...msg) => (
                    <H4
                        key="h4"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </H4>
                ),
                h5: (...msg) => (
                    <H5
                        key="h5"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </H5>
                ),
                h6: (...msg) => (
                    <div
                        key="h6"
                        {...props}
                        className={cn('hui-text-label-strong', textClasses)}
                    >
                        {msg}
                    </div>
                ),
                mini: (...msg) => (
                    <LabelMini
                        key="mini"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </LabelMini>
                ),
                primary: (...msg) => (
                    <BodyPrimary
                        key="primary"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </BodyPrimary>
                ),
                secondary: (...msg) => (
                    <BodySecondary
                        key="secondary"
                        {...props}
                        className={textClasses}
                    >
                        {msg}
                    </BodySecondary>
                ),
            }}
        />
    );

    return encapsulateP ? <p>{message}</p> : message;
};

export default React.memo<Props>(FormattedMessageText);
